import { render, staticRenderFns } from "./simplifyOwnerShops.vue?vue&type=template&id=6124a8d2&scoped=true"
import script from "./simplifyOwnerShops.vue?vue&type=script&lang=js"
export * from "./simplifyOwnerShops.vue?vue&type=script&lang=js"
import style0 from "./simplifyOwnerShops.vue?vue&type=style&index=0&id=6124a8d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6124a8d2",
  null
  
)

export default component.exports